/* <price-range> — dual-handle price slider that drives the facet min/max
   number inputs. It doesn't submit anything itself; on release it writes the
   value into the linked number input and fires its `input` event, which
   facets.js already debounces + applies. Re-inits automatically when facets.js
   re-renders the sidebar. */
(function () {
  'use strict';
  if (customElements.get('price-range')) return;

  customElements.define('price-range', class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this.minH = this.querySelector('[data-price-handle="min"]');
      this.maxH = this.querySelector('[data-price-handle="max"]');
      this.fill = this.querySelector('[data-price-fill]');
      this.minInput = document.getElementById(this.getAttribute('data-min-input'));
      this.maxInput = document.getElementById(this.getAttribute('data-max-input'));
      if (!this.minH || !this.maxH || !this.fill) return;

      var self = this;
      this.minH.addEventListener('input', function () { self.clamp('min'); self.paint(); });
      this.maxH.addEventListener('input', function () { self.clamp('max'); self.paint(); });
      this.minH.addEventListener('change', function () { self.commit('min'); });
      this.maxH.addEventListener('change', function () { self.commit('max'); });
      // Typing in the number inputs keeps the slider in sync.
      if (this.minInput) this.minInput.addEventListener('input', function () { self.syncFromInputs(); });
      if (this.maxInput) this.maxInput.addEventListener('input', function () { self.syncFromInputs(); });

      this.paint();
    }

    clamp(which) {
      var lo = +this.minH.value, hi = +this.maxH.value;
      if (lo > hi) {
        if (which === 'min') this.minH.value = hi;
        else this.maxH.value = lo;
      }
    }

    paint() {
      var floor = +this.minH.min, ceil = +this.minH.max || 1;
      var range = (ceil - floor) || 1;
      var a = ((+this.minH.value - floor) / range) * 100;
      var b = ((+this.maxH.value - floor) / range) * 100;
      this.fill.style.left = a + '%';
      this.fill.style.right = (100 - b) + '%';
    }

    commit(which) {
      var handle = which === 'min' ? this.minH : this.maxH;
      var input = which === 'min' ? this.minInput : this.maxInput;
      if (!input) return;
      // Blank = unbounded, so a handle parked at its extreme clears the filter.
      var atExtreme = which === 'min'
        ? (+handle.value <= +handle.min)
        : (+handle.value >= +handle.max);
      input.value = atExtreme ? '' : handle.value;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    syncFromInputs() {
      if (this.minInput) this.minH.value = this.minInput.value !== '' ? this.minInput.value : this.minH.min;
      if (this.maxInput) this.maxH.value = this.maxInput.value !== '' ? this.maxInput.value : this.maxH.max;
      this.clamp('min');
      this.paint();
    }
  });
})();
